import dyLoaded from './dy-loaded';

export default async function trackEvent(eventName, eventProperties) {
  try {
    await dyLoaded();
    const obj = {
      name: eventName,
      properties: {
        ...eventProperties,
      },
    };
    DY.API('event', obj);
    return Promise.resolve();
  } catch (e) {
    console.error('Error tracking event', e);
    return Promise.reject(e);
  }
}
